import { EPromoType } from '../types/newbuildingPromos';

export const MORTGAGE_PROMO_TYPES = [EPromoType.CianMortgage, EPromoType.Mortgage, EPromoType.Bank];
